import $http from './http'
import config from './config'

export default {
    name: 'tour',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    CreateOrder(data) {
        return $http.post(this.getUrl('/TourOrder/CreateOrder'), data);
    },
    OrderDetails(UniqueID) {
        return $http.get(this.getUrl(`/TourOrder/OrderDetails?UniqueID=${UniqueID}`));
    },
    OrderSubmit(UniqueID) {
        return $http.get(this.getUrl(`/TourOrder/OrderSubmit/${UniqueID}`));
    },
    // CreateReceiveRequest(data) {
    //     return $http.post(this.getUrl('/TourOrder/CreateReceiveRequest'), data);
    // },
    // TradeSubmit(id) {
    //     return $http.get(this.getUrl(`/TourOrder/SubmitReceiveRequest?TradeID=${id}`));
    // },
    OrderCannot(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderCannot?UniqueID=${id}`));
    },
    OrderDrawer(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderDrawer?UniqueID=${id}`));
    },
    OrderReject(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderReject?UniqueID=${id}`));
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/TourOrder/OrderResolve`), data);
    },
    UpdateGoods(goods) {
        return $http.post(this.getUrl('/TourOrder/UpdateGoods'), goods);
    },
    CreateAmend(amend) {
        return $http.post(this.getUrl(`/TourOrder/CreateAmend`), amend)
    },
    RefundJudge(UniqueID) {
        return $http.get(this.getUrl(`/TourOrder/RefundJudge?UniqueID=${UniqueID}`));
    },
    MessageSend(data) {
        return $http.post(this.getUrl('/TourOrder/MessageSend'), data);
    },
    UpdateOrder(data) {
        return $http.post(this.getUrl('/TourOrder/UpdateOrder'), data)
    },
    CheckChang(id) {
        return $http.get(this.getUrl(`/TrainOrder/CheckChang/${id}`))
    },
    OrderCancel(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderCancel?UniqueID=${id}`), {
            failTips: false
        });
    },
    OrderUnLock(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderUnLock?UniqueID=${id}`));
    },
    OrderLock(id) {
        return $http.get(this.getUrl(`/TourOrder/OrderLock?UniqueID=${id}`));
    },
    OrderRefund(data) {
        return $http.post(this.getUrl('/TourOrder/OrderRefund'), data);
    },
    ConfirmOrderPrice(data) {
        return $http.post(this.getUrl(`/TourOrder/ConfirmOrderPrice`), data)
    },
    UpdateOrderStatus(id) {
        return $http.get(this.getUrl(`/TourOrder/UpdateOrderStatus?UniqueID=${id}`));
    },
    UpdateTourOrderStatus(id){
        return $http.get(this.getUrl(`/TourOrder/UpdateTourOrderStatus?UniqueID=${id}`));
    },
    AmendStatusBack(id) {
        return $http.get(this.getUrl(`/TourOrder/AmendStatusBack?UniqueID=${id}`));
    },

    // SaveTeamInfos(data) {
    //     return $http.post(this.getUrl(`/TeamInfo/Save`), data);
    // },

    CreateTrade(data) {
        return $http.post(this.getUrl(`/TourOrder/CreateTrade`), data);
    },
    TradeStatusStatistics(data) {
        return $http.post(this.getUrl(`/TourOrder/TradeStatusStatistics`), data);
    },


















    // tourOrder() {
    //     return $http.post(this.getUrl('/TourOrder/List'));
    // },


    getOrderList(data) {
        return $http.post(this.getUrl('/TourOrder/List'), data);
    },




















    // ServiceList(data) {
    //     return $http.post(this.getUrl('/Uploadimgs/Uptest'), data);
    // },
    // getTourOrderList(data) {
    //     return $http.post(this.getUrl("/TourOrder/List"), data);
    // },
    // getTourDetails(id) {
    //     return $http.get(this.getUrl(`/TourOrder/TourDetails/${id}`));
    // },
    // saveTravle(data) {
    //     return $http.post(this.getUrl('/TravleAllDays/SaveTravleModel'), data);
    // },
    // getTravleInfo(id) {
    //     return $http.post(this.getUrl(`/TravleAllDays/GetInfo/${id}`));
    // },
    // getUpdatePass(data) {
    //     return $http.post(this.getUrl('/TourOrder/UpadatePass'), data);
    // },
    // getDeletePass(id) {
    //     return $http.get(this.getUrl(`/TourOrder/DeletePass/${id}`));
    // },
    // getLableInfo(id) {
    //     return $http.get(this.getUrl(`/LableInfo/GetLableInfo/${id}`));
    // },
    // saveLableInfo(data) {
    //     return $http.post(this.getUrl('/LableInfo/SaveLableInfo'), data);
    // },
    // SaveLastTime(data) {
    //     return $http.post(this.getUrl('/TourOrder/SaveLastTime'), data);
    // },
    // SavePrice(data) {
    //     return $http.post(this.getUrl('/TourOrder/SavePrice'), data);
    // },
    // GetInfoList(id) {
    //     return $http.get(this.getUrl(`/TravleAllDays/Trip/${id}`));
    // },
    // SaveFile(data) {
    //     return $http.post(this.getUrl('/TourOrder/SaveFile/'), data);
    // },
    // UploadAmend(data) {
    //     return $http.post(this.getUrl('/TourAmend/UploadAmend/'), data);
    // },
    // OrderDownload(data) {
    //     return $http.get(this.getUrl(`/TourOrder/OrderDownload/${data}`));
    // },
    // DownloadPass(data) {
    //     return $http.post(this.getUrl('/TourOrder/DownloadPass/'), data);
    // },
    // getlistMsg(id) {
    //     return $http.post(this.getUrl(`/LeaveMessage/GetMessage/${id}`));
    // },
    // saveMessageInfo(data) {
    //     return $http.post(this.getUrl('/LeaveMessage/LeaveMessageAdd'), data);
    // },
    // LookMessage(id) {
    //     return $http.post(this.getUrl(`/LeaveMessage/LookMessage/${id}`));
    // },
    // toLockOrder(id) {
    //     return $http.post(this.getUrl(`/LeaveMessage/DealOrder/${id}`));
    // },
    // getstatussum() {
    //     return $http.get(this.getUrl(`/TourOrder/GetTypeSum/`));
    // },
    Canceled(id) {
        return $http.post(this.getUrl(`/TourOrder/Cancel/${id}`));
    },
    // uploadtourindeximg(data) {
    //     return $http.post(this.getUrl('/TourIndexImg/IndexImgUpdate'), data);
    // },
    // imgdelete(id) {
    //     return $http.get(this.getUrl(`/TourIndexImg/Delete/${id}`));
    // },
    // SendChit(data) {
    //     return $http.post(this.getUrl('/TourOrder/SendChit'), data);
    // },
    // Getlogs(id) {
    //     return $http.get(this.getUrl(`/TourOrder/GetLogs/${id}`));
    // },
    // UpPassImges(data) {
    //     return $http.post(this.getUrl('/TourOrder/UploadPass'), data);
    // },
    // GetPassImgs(id) {
    //     return $http.get(this.getUrl(`/TourOrder/GetPassImgs/${id}`));
    // },
    // UpdatePrice(data) {
    //     return $http.post(this.getUrl('/TourOrder/UpdatePrice'), data);
    // },
    // Receivables(data) {
    //     return $http.post(this.getUrl('/TourOrder/Receivables'), data);
    // },
    // buildamend(data) {
    //     return $http.post(this.getUrl('/TourAmend/BuildAmendOrder'), data);
    // },
    // AmendList(data) {
    //     return $http.post(this.getUrl('/TourAmend/List'), data);
    // },
    // AmendDetails(UniqueID) {
    //     return $http.get(this.getUrl(`/TourOrder/AmendDetails?UniqueID=${UniqueID}`));
    // },
    // ChangeAmendStatus(data) {
    //     return $http.post(this.getUrl('/TourAmend/ChangAmendStatus'), data);
    // },
    // GetAmendSum() {
    //     return $http.post(this.getUrl('/TourAmend/GetAmendSum'));
    // },
    // SubSupply(data) {
    //     return $http.post(this.getUrl('/TourAmend/SubSupply'), data);
    // },
    // PassApproval(data) {
    //     return $http.post(this.getUrl('/TourAmend/PassApproval'), data);
    // },
    // RefuseApproval(data) {
    //     return $http.post(this.getUrl('/TourAmend/RefuseApproval'), data);
    // },
    // GetAmendLogs(id) {
    //     return $http.get(this.getUrl(`/TourAmend/GetAmendLogs/${id}`));
    // },
    // savetradesetting(data) {
    //     // return $http.post(this.getUrl('/TradeSetting/SaveTradeSetting'), data);
    // },
    // //旅游政策图片的上床
    // uploadImage(data) {
    //     return $http.post('/uploadfile/images/Upload/Tour', data);
    // },
    // uploadFile(data) {
    //     return $http.post('/uploadfile/files/Upload/Tour', data);
    // },
    // setIndexImg(data) {
    //     return $http.post(this.getUrl(`/TourIndexImg/Add`), data);
    // },
    // getinideximglist(id) {
    //     return $http.get(this.getUrl(`/TourIndexImg/Imglist/${id}`));
    // },
    // getCgOrderDetail(id) {
    //     return $http.get(this.getUrl(`/TourOrderSearch/TourOrderDetail/${id}`))
    // },
    // cuslevelcodeadd(data) {
    //     return $http.post(this.getUrl('/CustomerLevelCode/Added'), data)
    // },
    // searchmanage(data) {
    //     return $http.post(this.getUrl('/CustomerLevelCode/getManages'), data)
    // },
    // dellevelcode(id) {
    //     return $http.post(this.getUrl(`/CustomerLevelCode/Delete/${id}`));
    // },
    createdemandorder(data) {
        return $http.post(this.getUrl('/tourorder/createdemandorder'), data);
    },
    // GetAllSubscribe(data) {
    //     return $http.post(this.getUrl('/TourOrder/GetAllSubscribe'), data)
    // },
    // payapplyadd(data) {
    //     return $http.post(this.getUrl('/TourOrder/PayMoneyAdd'), data)
    // },
    // touramendpeople(id) {
    //     return $http.get(this.getUrl(`/TourAmend/AmendPeople/${id}`))
    // },
    // amendorder(data) {
    //     return $http.post(this.getUrl('/TourAmend/createamend'), data);
    // },
    CreateOrderByPreference(data) {
        return $http.post(this.getUrl('/demand/CreateOrderByPreference'), data);
    },
    SearchOrders(id) {
        return $http.get(this.getUrl(`/TourOrder/SearchOrders?UniqueID=${id}`));
    },
    SearchExtras(data) {
        return $http.post(this.getUrl('/TourOrder/SearchExtras'), data);
    },
    CreateExtras(data) {
        return $http.post(this.getUrl('/TourOrder/CreateExtras'), data);
    },
    TeamStatistics(data) {
        return $http.post(this.getUrl('/TourOrder/TeamStatistics'), data);
    },
    

}



// WEBPACK FOOTER //
// ./src/apis/tourApis.js